import { useMemo } from 'react';
import { MAvatar } from '../../../@material-extend';
import { useSelector } from '../../../../redux/store';
import useAuth from '../../../../hooks/useAuth';
import createAvatar from '../../../../utils/createAvatar';
import { Badge } from '@mui/material';

const MyAvatar = ({ ...other }) => {
  const { user, isPartner, isClient } = useAuth();
  const { unseenClientFiles, unseenCompanyFiles, unseenPartnerFiles } = useSelector((state) => state.files);

  const avatarBageContent = useMemo(() => {
    if (isPartner) {
      return unseenCompanyFiles + unseenClientFiles + unseenPartnerFiles;
    } else if (isClient) {
      return unseenClientFiles;
    } else {
      return 0;
    }
  }, [unseenCompanyFiles, unseenClientFiles, unseenPartnerFiles]);

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      badgeContent={avatarBageContent || 0}
      color="error"
    >
      <MAvatar src={user.photoURL} alt={user.firstname} color={user.photoURL ? 'default' : 'primary'} {...other}>
        {createAvatar(user.firstname).name}
      </MAvatar>
    </Badge>
  );
};

export default MyAvatar;
